export const REQUIRED_FIELDS = ["primary_name", "secondary_name", "wedding_date"];

export function validateRequired(data) {
    const errors = {};
    REQUIRED_FIELDS.forEach((f) => {
        const v = (data?.[f] ?? "").toString().trim();
        if (!v) errors[f] = true;
    });
    return errors;
}

export function hasErrors(errors) {
    return errors && Object.keys(errors).length > 0;
}

// Which section contains each required field — used to scroll/swipe to it.
export const FIELD_TO_SECTION = {
    primary_name: "couple",
    secondary_name: "couple",
    wedding_date: "date",
};
